import { useCallback, useState } from 'react';
import { INITIAL_ARCHIVED, nowStr } from './archiveMock';

// 模块级存储：跨组件共享本次会话的归档状态
let ARCHIVE_STORE = { ...INITIAL_ARCHIVED };

/**
 * 定制项目归档状态（管理端）
 * 返回：
 * - getArchived(id)：取某项目归档信息 { archivedAt } 或 null
 * - archive(id)：归档项目（从主列表隐藏，移入「已归档」）
 * - unarchive(id)：取消归档（回到主列表）
 * - archivedIds：已归档项目 id 列表
 */
export const useArchive = () => {
    const [, setVersion] = useState(0);
    const commit = useCallback((next) => { ARCHIVE_STORE = next; setVersion((v) => v + 1); }, []);

    const getArchived = useCallback((id) => ARCHIVE_STORE[id] || null, []);

    const archive = useCallback((id) => {
        commit({ ...ARCHIVE_STORE, [id]: { archivedAt: nowStr() } });
    }, [commit]);

    const unarchive = useCallback((id) => {
        const next = { ...ARCHIVE_STORE };
        delete next[id];
        commit(next);
    }, [commit]);

    return { getArchived, archive, unarchive, archivedIds: Object.keys(ARCHIVE_STORE) };
};

export default useArchive;
